export default __webpack_public_path__ + "static/leigh-cfe7ff487465ca30986c9c3ae4bf4083.jpeg";